
<p>seřadit podle</p>

<div
  class="radio-group"
>
  <div 
    class="radio-button" 
    *ngFor="let option of sortOptions" 
    [class.selected]="isSelected(option)"
  ><a 
    class="sort-link" 
    [routerLink]="['./']" 
    [queryParams]="getQueryParams(option)"
    queryParamsHandling=""
    matRipple
  > 
    <span class="radio-icon">
      <span class="radio-icon-outer"></span>
      <span class="radio-icon-inner"></span>
    </span>
    <span class="label">{{option.description}}</span>
  </a>
    
  </div>
</div>

